import OlMap, { MAX_ZOOM } from '@m1/ol-map';
import classNames from 'classnames/bind';
import React from 'react';
import { RiFullscreenLine, RiZoomOutLine, RiZoomInLine, RiCrosshairLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';

import styles from './index.module.scss';

import actions from '@/actions';
import Bar from '@/components/ui/Bar';

const cx = classNames.bind(styles);

const MapTool = () => {
  const dispatch = useDispatch();
  const zoom = useSelector((state) => state.map.zoom);

  const fitBounds = () => {
    dispatch(actions.robot.setFocus());
    OlMap.fitBoundsAuto();
  };

  const zoomOut = () => {
    const view = OlMap.getMap().getView();
    view.animate({
      zoom: view.getZoom() - 1,
      duration: 300,
    });
  };

  const zoomIn = () => {
    const view = OlMap.getMap().getView();
    view.animate({
      zoom: view.getZoom() + 1,
      duration: 300,
    });
  };

  const moveToCurrent = () => {
    window.navigator.geolocation.getCurrentPosition(({ coords }) => {
      OlMap.getMap().getView().setZoom(MAX_ZOOM);
      OlMap.setCenter({ lng: coords.longitude, lat: coords.latitude });
    });
  };

  return (
    <>
      <div className={cx('group')}>
        <div className={cx('button')} onClick={fitBounds}>
          <RiFullscreenLine size={20} title="Fit Bounds" color="white" />
        </div>
        <div className={cx('button')} onClick={moveToCurrent}>
          <RiCrosshairLine size={20} title="Current Location" color="white" />
        </div>
      </div>
      <Bar size={24} horizontal />
      <div className={cx('group')}>
        <div className={cx('zoom')}>{Math.round(zoom)}</div>
        <div className={cx('button')} onClick={zoomOut}>
          <RiZoomOutLine size={20} title="Zoom Out" color="white" />
        </div>
        <div className={cx('button')} onClick={zoomIn}>
          <RiZoomInLine size={20} title="Zoom In" color="white" />
        </div>
      </div>
    </>
  );
};

export default MapTool;
